import React, { useEffect, useState } from 'react';

import useTranslate from '../../../common/hooks/useTranslate';
import { useDispatch, useSelector } from 'react-redux';

import { getProfile, getActivity, getUserSettings, getAcceptedAgreements } from '../../services/userService';

import { RootState } from '../../../redux/store';
import { POPUP } from '../../../redux/types';

import { IProfile } from '../types/IProfile';

import Main from '../../layout/main/main';
import ContactDetails from '../components/contactDetails/contactDetails';
import UserSettings from '../components/userSettings/userSettings';
import ActivityLog from '../components/activityLog/activityLog';
import AcceptedAgreements from '../components/acceptedAgreements/acceptedAgreements';

import './profile.scss';

const Profile: React.FC = () => {
  const [activity, setActivity] = useState<any[]>([]);
  const [acceptedAgreements, setAcceptedAgreements] = useState<any[]>([]);
  const [userSettings, setUserSettings] = useState<any[]>([]);
  const [profile, setProfile] = useState<IProfile>({
    id: 0,
    firstName: '',
    lastName: '',
    emails: [],
    phones: [],
    addresses: [],
  });
  const [loading, setLoading] = useState<boolean>(true);
  const [screenSize, setScreenSize] = useState<number>(0);

  const { t } = useTranslate();
  const dispatch = useDispatch();

  const impersonate = useSelector((state: RootState) => state.impersonate);

  useEffect(() => {
    setScreenSize(screen.width);
    Promise.all([getProfile(), getActivity(), getUserSettings(),getAcceptedAgreements()]).then((res: any[]) => {
      setProfile(res[0].data[0]);
      setActivity(res[1].data);
      setUserSettings(res[2]);
      setAcceptedAgreements(res[3]);
      setLoading(false);
    }).catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
  }, [impersonate]);

  return (
    <Main title={`${screenSize < 960 ? profile?.firstName + ' ' + profile?.lastName : t('PROFILE.PAGE_TITLE')}`}
          additionalTitle={`${screenSize < 960 ? '' : (profile?.firstName || '') + ' ' + (profile?.lastName || '')}`}>
      <div className='profile-wrapper'>
        <ContactDetails profile={profile} loadingProfile={loading} />
        <UserSettings settings={userSettings} />
        <ActivityLog activity={activity} loadingActivity={loading} />
        <AcceptedAgreements data={acceptedAgreements} loadingActivity={loading} />
      </div>
    </Main>
  );
};

export default Profile;
